import ReactQuill from 'react-quill';
import { Button, Col, FormGroup, Label, Row } from 'reactstrap';
import { Field, FieldArray, Form, useFormikContext } from 'formik'

import styles from "./AddApplicantForm.module.scss";
import EditorToolbar, { formats, undoChange, redoChange } from "../../components/common/CustomEditor";
import MultiSelect from '../common/Form/Multiselect';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const CreateEventForm = (props) => {
  const { errors, touched } = props;

  const [options, setOptions] = useState([]);
  const inetviewer = useSelector((state) => state.jobProfiles.searchUser);

  const { setFieldValue, values } = useFormikContext();

  const today = new Date();

  const hasWhiteSpace = (val) => {
    const strippedHtml = val.replace(/<[^>]+>/g, '');
    return strippedHtml.trim().length > 0 ? true : false;
  }

  useEffect(() => {
    let merger = [];
    if (props?.activeData?.interviewerIds !== "") {
      const [value, label] = [
        props?.activeData?.interviewerIds.split(","),
        props?.activeData?.interviewerNames.split(","),
      ];
      merger = value?.map((node, index) => ({
        value: node,
        label: `${label[index]}`,
      }));
    }

    if (inetviewer && inetviewer.length > 0) {
      const resVal = inetviewer.map((val) => {
        return {
          value: val?.id,
          label: val?.name,
        };
      });
      let finalArr = resVal;
      if (merger && merger.length > 0) {
        finalArr.concat(merger);
      }
      setOptions([
        ...new Map(finalArr.map((item) => [item["value"], item])).values(),
      ]);
    } else {
      setOptions(merger);
    }
  }, [inetviewer]);

  return (
    <Form className={`${styles.positionForm}`} encType='multipart/form-data'>
      <Row>
        <Col md="6" xs="12">
          <FormGroup className='form-group'>
            <Label>Title <span style={{color: 'red'}}>*</span></Label>
            <Field className='form-control'
              name="summary" />
            {errors?.summary && touched?.summary ? (
              <div className={styles?.formError}>{errors?.summary}</div>
            ) : null}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup className='form-group'>
            <Label>Date & Time <span style={{color: 'red'}}>*</span></Label>
            <Field
              className='form-control'
              name='startTime'
              type='datetime-local'
              min={today.toISOString().slice(0, 16)}
               />
            {errors?.startTime && touched?.startTime ? (
              <div className={styles?.formError}>{errors?.startTime}</div>
            ) : null}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="6" xs="12">
          <FormGroup>
            <Label>Duration</Label>
            <Field className='form-control'
              name='duration' as='select'>
              <option value="15">15 mins</option>
              <option value="30">30 mins</option>
              <option value="45">45 mins</option>
              <option value="60">1 hr</option>
              <option value="75">1 hr 15 mins</option>
              <option value="90">1 hr 30 mins</option>
              <option value="105">1 hr 45 mins</option>
              <option value="120">2 hr</option>
              <option value="135">2 hr 15 mins</option>
              <option value="150">2 hr 30 mins</option>
              <option value="165">2 hr 45 mins</option>
              <option value="180">3 hr</option>
              <option value="195">3 hr 15 mins</option>
              <option value="210">3 hr 30 mins</option>
              <option value="225">3 hr 45 mins</option>
            </Field>
          </FormGroup>
        </Col>
        <Col md="6" xs="12">
          <FormGroup className='form-group'>
            <Label>Location</Label>
            <Field className='form-control'
              name='location' as='select'>
              <option value="remote">Remote</option>
              <option value="office">Office</option>
            </Field>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label>Interviewers <span style={{color: 'red'}}>*</span></Label>
            <Field 
              className='form-control'
              name='interviewers'
              isMulti={true}
              component={MultiSelect}
              options={options}
            />
          </FormGroup>  
        </Col>
      </Row>
      <Row className='mt-1'>
        <Col md="6" xs="12">
          <FormGroup>
            <Label>View Guest List</Label>
            <Field className="ms-3" type="checkbox" name="guestsCanSeeOtherGuests" />
          </FormGroup>
        </Col>
        <Col md="6" xs="12" l>
          <FormGroup className='form-group'>
            <Label>Visibility</Label>
            <span className='mx-3'>
              <Field type="radio" name="visibility" value="public" />
              <label className='mx-2' htmlFor="option1">Public</label>
            </span>
            <span>
              <Field type="radio" name="visibility" value="private" />
              <label className='ms-2' htmlFor="option2">Private</label>
            </span>
          </FormGroup>
        </Col>
      </Row>
      <FormGroup className='form-group'>
        <Label>Description</Label>
        <div className="interviewDesc">
          <EditorToolbar className="description" />
          <ReactQuill
            theme="snow"
            name="description"
            id="description"
            value={values?.description}
            onChange={(val) => {
              if (hasWhiteSpace(val)) {
                setFieldValue("description", val)
              } else {
                setFieldValue("description", "")
              }
            }}
            placeholder={"Please add interview description"}
            modules={{
              toolbar: {
                container: ".description",
                handlers: {
                  undo: undoChange,
                  redo: redoChange
                }
              },
              history: {
                delay: 500,
                maxStack: 100,
                userOnly: true
              }
            }}
            formats={formats}
          />
        </div>
      </FormGroup>
      <Button type='submit' className={styles.brandButton}>
        {props?.isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : props.selRound === 'new' ? 'Schedule' : 'Reschedule'}
      </Button>
    </Form>
  )
}

export default CreateEventForm;